import { Autocomplete, TextField } from "@mui/material";
import { RoundedTextField } from "shared/rounded-textField/RoundedTextField";

export const RoundedAutocomplete = ({
    value,
    onChange,
    onBlur,
    options,
    label,
    error,
    helperText,
    name
}: {
    value: string;
    onChange: (value: string) => void;
    onBlur: () => void;
    options: { label: string; value: string }[];
    label: string;
    error?: boolean;
    helperText?: string;
    name: string;
}) => {
    return (
        <Autocomplete
            options={options}
            value={options.find(option => option.value === value) || null}
            onChange={(_event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            onBlur={onBlur}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    error={error}
                    helperText={helperText}
                    name={name}
                />
            )}
            fullWidth
        />
    );
};